module.exports = __webpack_public_path__ + "img/api.25df67d5.png";